var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBritishVirginIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.63 18.97a6.7 6.7 0 0 1-3.92-1.55q-.24.2-.43.2c-.3-.05-.84-.41-.9-.86a.9.9 0 0 1 .42-.79c.24-.19.49-.44.52-.51q.22-.3.42-.33a1.4 1.4 0 0 1-.14-.59l.03-6.91h8.04v6.92q0 .32-.16.62c.3.09.45.28.6.46.13.15.3.36.42.4l.15.1a.9.9 0 0 1-.2 1.27q-.28.16-.58.18a.6.6 0 0 1-.39-.14 6.3 6.3 0 0 1-3.75 1.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#006129",
    d: "M22.58 17.49c-2.44-1.26-3.71-1.96-3.73-2.95l.03-6.67h7.54v6.68c.01.9-1.36 1.76-3.73 2.94l-.06.02z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.8 15.2c-.03-.7-.45-2.23-.6-2.72.32-.84.96-2.3-.2-2.8-.16-.17.16 0 .25-.27.3-.34-.27-1.11-.63-.89-.71.18-.01.33-.33.61-.06.6.6.28-.05.78-.23.1-.31.73-.31.97-.25.38-1.22 1.18-.7 1.62.3-.14.1-.59.28-.73.13-.09.5-.36.63-.53.04.28-.36.98-.16 1.01-.26.83-.2 1.93-.15 2.71-.11.23-.2.66.11.72-.23-.01-.14.2 0 .22.13-.17.93-.2.66-.42.16.02.06.33.36.23.22.6.51-.1.6-.17.14-.12.42.03.24-.34m-.6-3.77c.08-.16-.02-.32.07-.46.2.14-.05.8-.06.46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M22.63 18.72c-1.9 0-3.5-1.27-3.94-1.64l-.05.06c-.1.1-.23.22-.36.22-.17-.02-.6-.3-.64-.63s.26-.52.3-.54c.22-.18.58-.51.62-.65q.14-.18.26-.16c.2 0 .38.16.4.18.03.03 1.54 1.74 3.22 1.74h.14a4.6 4.6 0 0 0 3.23-1.48c.05-.1.3-.43.58-.43.23.05.36.2.53.4.16.2.34.42.52.48l.08.06c.23.37 0 .74-.19.86a1 1 0 0 1-.43.14l-.14-.03a.3.3 0 0 1-.19-.21v-.03c-.4.36-1.98 1.67-3.81 1.67z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritishVirginIslands);
export default __webpack_public_path__ + "static/media/british-virgin-islands.9a51aa1f562cc141293ac6e0be4f3a99.svg";
export { ForwardRef as ReactComponent };